<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="input-group">
          <h5 class="mt-2">کلیه محصولات با برنامه</h5>
          <div class="input-group-prepend custom">
            <div class="input-group-text ml-3 h-100">
              <i class="icon-calendar-blank-outline"></i>
              <span> از تاریخ </span>
            </div>
            <date-picker
              v-show=true
              :auto-submit="true"
              format="jYYYY-jMM-jDD"
              @input="setDateFromDatePicker"
              ref="datePicker1"
            >
              <slot>
                <input
                  :readonly=true
                  :auto-submit="true"
                  v-model="startPlanningDateJ"
                  class="form-control date-input"
                  @click="toggleStartPlanningDatePicker"
                >
              </slot>
            </date-picker>
            <div class="input-group-text ml-3 h-100">
              <i class="icon-calendar-blank-outline"></i>
              <span> تا تاریخ </span>
            </div>
            <date-picker
              v-show=true
              :auto-submit="true"
              format="jYYYY-jMM-jDD"
              @input="setDateFromDatePicker"
              ref="datePicker2"
            >
              <slot>
                <input
                  :readonly=true
                  v-model="endPlanningDateJ"
                  class="form-control date-input"
                  @click="toggleEndPlanningDatePicker"
                >
              </slot>
            </date-picker>
          </div>

        </div>
        <hr/>
        <!--******************** PRODUC PLANNING TABLE ************************************************-->
        <div class="col-12 text-center m-2">
          <button @click="getProduct" class="btn iconed btn-secondary"><i
            class="icon-bd-plus"></i><span>برنامه جدید</span></button>
        </div>
        <div v-if="isLoading">
          <Preloader/>
        </div>
        <div v-else>
          <table class="table table-striped">
            <thead>
            <tr>
              <th scope="col" class="text-center">کد برنامه</th>
              <th scope="col" class="text-center">نام محصول</th>
              <th scope="col" class="text-center">موجودی انبار</th>
              <th scope="col" class="text-center">برنامه ریزی شده</th>
              <th scope="col" class="text-center">در دست تولید</th>
              <th scope="col" class="text-center">تولید شده</th>
              <th scope="col" class="text-center">مشاهده جزئیات</th>

            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in planning">
              <!--<th scope="row" class="text-center">{{item.id}}</th>-->
              <td class="text-center">{{item.planning.programCode}}</td>
              <td class="text-center">{{item.productName}}</td>
              <td class="text-center">{{item.totlalStock}}</td>
              <td class="text-center">{{item.totlalPlanCount}}</td>
              <td class="text-center">{{item.totlalPlanInProduction}}</td>
              <td class="text-center">{{item.totlalPlanProducted}}</td>
              <td class="text-center">
                <button @click="showProgramDetail(item.productId , item.programCodeId)" class="btn iconed btn-success"><i
                  class="icon-file-document-box-multiple"></i><span></span></button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

    <!--********************************************************************-->
    <b-modal id="productOrder"
             ref="productOrder"
             centered
             size="lg"
             title="برنامه ریزی تولید"
             :ok-title="'ذخیره'"
             :cancel-title="'لغو'"
             @ok="sendPrePlanning"
    >
      <div class="row mb-2">

        <div class="col-12">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نام کالا</span>
              </div>
            </div>
            <input
              v-model="product.productName"
              type="text"
              class="form-control"
              @click="openProductModal"
              placeholder="ابتدا کالا را انتخاب کنید"
              readonly
            >
            <!--v-bind:class="{ 'hover-pointer': mode!=='view' }"-->
          </div>
        </div>

      </div>
      <div class="row mb-2" v-if="showPlanningModal">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>الگوی تولید</span>
              </div>
            </div>
            <vs-select
              ref="selectPattern"
              :data="names"
              :header="{label:'name'}"
              :mode="'edit'"
              :is-header="true"
              :selected-val="selectedProductPattern"
              @dataChanged="patternSelect"
            ></vs-select>
          </div>

        </div>
        <div class="col-2">
          <div class="input-group ">
            <div class="input-group-prepend custom">
              <span class="input-group-text">تعداد</span>
            </div>
            <input class="form-control" type="number" placeholder="تعداد مورد نظر" v-model="createPatternModel.count"
                   @change="countChange"/>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group ">
            <div class="input-group-prepend custom">
              <span class="input-group-text">زمان تقریبی انجام کار</span>
            </div>
            <input readonly="true" class="form-control" type="number" placeholder="زمان تقریبی" v-model="planningTime"/>
          </div>
        </div>
        <div class="input-group col-sm-12 mt-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب شیفت کاری</span>
              </div>
            </div>
            <!--<input v-model="server.name" type="text" class="form-control">-->
            <vs-select
              ref="companies"
              :data="shiftList"
              :header="{label:'name', multiple: true}"
              :mode="'edit'"
              :is-header="true"
              :selected-val="shiftSelectedVal"
              @onChange="onShiftChange"
            ></vs-select>
          </div>


        </div>
        <div class="input-group col-sm-6 mt-2 h-100">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>تاریخ شروع تولید</span>
            </div>
          </div>
          <date-picker
            v-show=true
            :auto-submit="true"
            :min="todayDateJ"
            :highlight="avilableDate"
            format="jYYYY-jMM-jDD"
            @input="setDateFromDatePicker"
            ref="datePicker4"
          >
            <slot>
              <input
                :readonly=true
                v-model="selsestDate"
                class="form-control date-input"
                @click="toggleStartDatePicker"
              >
            </slot>
          </date-picker>

        </div>
        <div class="input-group col-sm-6 mt-2 h-100">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>تعداد برنامه ریزی شده تا کنون : {{totalCount}} عدد</span>
            </div>
          </div>


        </div>
      </div>
      <hr/>
        <span class="mx-2 my-2 w-100 text-center">برنامه ریزی با توجه به موجودی فعلی محصول و موجودی مواد اولیه انجام میشود. یعنی اگر موجودی داشته باشیم برنامه ایجاد نمیشود</span>
      <!--<div class="row" v-if="showPlanningModal">-->
        <!--<h5 class="mx-2 my-2">موجودی مواد اولیه این کالا تا زمان شروع برنامه</h5>-->
        <!--<div class="row my-3 text-center" v-if="nodataDate">-->
          <!--<div class="col-12 mt-3">-->
            <!--<h5>موجودی ثبت نشده است</h5>-->

          <!--</div>-->
        <!--</div>-->
        <!--<div class="row my-2" v-else>-->
          <!--<div class="col-12 mt-3">-->
            <!--<table class="table table-striped">-->
              <!--<thead>-->
              <!--<tr>-->
                <!--<th scope="col" class="text-center">نام محصول</th>-->
                <!--<th scope="col" class="text-center">واحد</th>-->
                <!--<th scope="col" class="text-center">کارگاه ها</th>-->
                <!--<th scope="col" class="text-center">موجودی سایر کارگاه ها</th>-->

              <!--</tr>-->
              <!--</thead>-->
              <!--<tbody>-->
              <!--<tr v-for="(item, indexDate) in dateQuantity">-->

                <!--<td class="text-center">{{item.name}}</td>-->
                <!--<td class="text-center">{{item.unitName}}</td>-->
                <!--<td class="text-center">-->
                  <!--<table class="table table-striped">-->
                    <!--<thead>-->
                    <!--<tr>-->
                      <!--<th scope="col" class="text-center">نام کارگاه در الگوی تولید</th>-->
                      <!--<th scope="col" class="text-center">موجودی انبار کارگاه الگوی تولید</th>-->
                      <!--<th scope="col" class="text-center">تعداد مورد نیاز</th>-->
                    <!--</tr>-->
                    <!--</thead>-->
                    <!--<tbody>-->
                    <!--<tr v-for="(ite, indexcompanyNeed) in item.companyNeedQuantitys">-->
                      <!--<td class="text-center">{{ite.companyName}}</td>-->
                      <!--<td class="text-center">{{ite.totalQuantity}}</td>-->
                      <!--<td class="text-center">{{ite.totalNeed}}</td>-->
                    <!--</tr>-->
                    <!--</tbody>-->
                  <!--</table>-->
                <!--</td>-->
                <!--<td v-if="item.companyQuantitys == null">-->
                  <!--<h6 class="text-center">موجودی ثبت نشده است</h6>-->
                <!--</td>-->
                <!--<td v-else>-->
                  <!--<table class="table table-striped">-->
                    <!--<thead>-->
                    <!--<tr>-->
                      <!--<th scope="col" class="text-center">نام کارگاه</th>-->
                      <!--<th scope="col" class="text-center">موجودی انبار</th>-->
                      <!--<th scope="col" class="text-center">انتقال به کارگاه الگو</th>-->
                    <!--</tr>-->
                    <!--</thead>-->
                    <!--<tbody>-->
                    <!--<tr v-for="(it, indexQuantity) in item.companyQuantitys">-->
                      <!--<td class="text-center">{{it.companyName}}</td>-->
                      <!--<td class="text-center">{{it.quantity}}</td>-->
                      <!--<td class="text-center">-->
                        <!--<button class="btn iconed btn-secondary"-->
                                <!--@click="onTransferClicked2(indexDate,indexQuantity,dateQuantity)"><i-->
                          <!--class="icon-content-duplicate"></i><span>انتقال</span></button>-->
                      <!--</td>-->
                    <!--</tr>-->
                    <!--</tbody>-->
                  <!--</table>-->
                <!--</td>-->

              <!--</tr>-->
              <!--</tbody>-->
            <!--</table>-->
          <!--</div>-->

        <!--</div>-->


      <!--</div>-->

    </b-modal>
    <!--********************************************************************-->
    <b-modal id="productDetail"
             ref="productDetail"
             centered
             size="lg"
             title="گزارش برنامه تولید محصول"
             :ok-title="'خروج'"
             :cancel-title="'لغو'"
    >
      <div class="row justify-content-center">
        <div class="col-6 input-group col-sm-4 text-center mt-5 " style="justify-content: center;">
          <date-picker
            v-show=true
            :visibel=true
            :highlight="highlightOrder"
            format="jYYYY-jMM-jDD"
            @input="setDateFromDatePicker"
            ref="datePicker3"
          >
            <slot>
              <button @click="showOrderTimesheet" class="btn iconed btn-info"><i
                class="icon-calendar-blank-outline"></i><span>مشاهده تقویم برنامه ریزی</span></button>
            </slot>
          </date-picker>
        </div>
        <div class="col-6 input-group col-sm-4 text-center mt-5 " style="justify-content: center;">
          <button @click="showOrderTimesheetList" class="btn iconed btn-success"><i
            class="icon-file-document-box-multiple"></i><span>مشاهده لیست برنامه ریزی</span></button>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="input-group col-sm-4 text-center mt-5 " style="justify-content: center;">
          <button @click="getRawMaterial" class="btn iconed btn-danger"><i
            class="icon-dropbox"></i><span>مواد اولیه</span></button>
        </div>
        <div class="input-group col-sm-4 text-center mt-5 " style="justify-content: center;">
          <button @click="sendOrderToProduce" class="btn iconed btn-info"><i
            class="icon-file-document-box-multiple"></i><span>دستور تولید</span></button>
        </div>
        <div class="input-group col-sm-4 text-center mt-5 " style="justify-content: center;">
          <button @click="showdeletePlanModal" class="btn iconed btn-danger"><i
            class="icon-bd-delete"></i><span>حذف برنامه</span></button>
        </div>
      </div>

    </b-modal>

    <!-------------------------------------------------------------------------------->
    <b-modal
      ref="selectProductModal"
      title="انتخاب کالا"
      size="xl"
      ok-only
      ok-title="تایید"
      @ok="onSelectProductOk"
    >
      <div ref="productsContainer">
        <products
          :is-select-mode="true"
          @onRowSelect="selectProduct"
          @onRowDoubleClicked="openProductDetailModal"
        ></products>
      </div>
    </b-modal>
    <!--********************************************************************-->
    <b-modal id="modal-center"
             ref="orderPlanningList"
             v-if="showModal === true"
             centered
             size="lg"
             title="جزئیات برنامه سفارش"
             :cancel-title="'لغو'"
             :ok-title="'بستن'"
    >
      <div class="row mb-2">
        <table class="table table-striped">
          <thead>
          <!--<tr>-->
          <!--<th scope="col" class="text-center">شماره برنامه</th>-->
          <!--</tr>-->
          </thead>
          <tbody>
          <tr v-for="(i, index) in planningList">

            <th scope="row" class="text-center">{{i.programCode}} (تعداد {{i.totalCount}} عدد)</th>
            <!--**********************-->
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col" class="text-center">تاریخ</th>
                <th scope="col" class="text-center">نام محصول</th>
                <th scope="col" class="text-center">نام الگو</th>
                <th scope="col" class="text-center">کارگاه</th>
                <th scope="col" class="text-center">نام شیفت</th>
                <th scope="col" class="text-center">ساعت</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in planningList[index].ordersPrograms">
                <td class="text-center">{{item.date}}</td>
                <td class="text-center">{{item.productName}}</td>
                <td class="text-center">{{item.patterrnName}}</td>
                <td class="text-center">{{item.companyName}}</td>
                <td class="text-center">{{item.shiftName}}</td>
                <td class="text-center">{{item.times}}</td>

              </tr>
              </tbody>
            </table>
            <!--***********************-->
          </tr>
          </tbody>
        </table>

      </div>

      <!--</div>-->
    </b-modal>
    <!--********************************************************************-->
    <b-modal id="modal-center"
             ref="deletePlanModal"
             v-if="showModal === true"
             centered
             size="lg"
             title="حذف برنامه"
             :ok-title="'حذف'"
             :cancel-title="'لغو'"
             @ok="deletPlanning"
    >
      <div class="row mb-2">

        <div class="input-group col-sm-12 mt-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب برنامه</span>
              </div>
            </div>
            <!--<input v-model="server.name" type="text" class="form-control">-->
            <vs-select
              ref="companies"
              :data="programList"
              :header="{label:'programCode', multiple: true}"
              :mode="'edit'"
              :is-header="true"
              :selected-val="deleteprogramListVal"
              @onChange="onDeleteProgramListChange"
            ></vs-select>
          </div>
        </div>

      </div>

      <!--</div>-->
    </b-modal>

    <b-modal id="modal-center"
             ref="sentToProduct"
             v-if="showModal === true"
             centered
             size="lg"
             title="ارسال برنامه برای تولید"
             :ok-title="'ذخیره'"
             :cancel-title="'لغو'"
             @ok="sendPlanningToProduct"
    >
      <div class="row mb-2">

        <div class="input-group ">
          <div class="input-group col-8 mt-2">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب برنامه</span>
              </div>
            </div>
            <!--<input v-model="server.name" type="text" class="form-control">-->
            <vs-select
              ref="companies"
              :data="programListNotsend"
              :header="{label:'str', multiple: true}"
              :mode="'edit'"
              :is-header="true"
              :selected-val="programListVal"
              @onChange="onProgramListChange"
            ></vs-select>
          </div>
          <div class="col-3  mt-2">
            <div class="input-group">
              <div class="input-group-prepend custom">
                <div class="input-group-text">
                  <span>اولویت</span>
                </div>
              </div>

              <vs-select
                ref="selectedPriority"
                :isHeader="true"
                :data="priority"
                :selectedVal="priority.title"
                :header="{label:'title'}"
                :mode="'edit'"
                @dataChanged="priorityTitleSelect"
                style="max-width:50% !important; "
              ></vs-select>
              <!--v-if="!sellOnly && mode!=='view'"-->
            </div>
          </div>

          <div class="input-group-prepend custom col-sm-12 mt-2">
            <div class="input-group-text">
              <span>دستورات کار </span>
            </div>
            <input type="text" class="form-control" v-model="workDescription">

          </div>
        </div>

      </div>

      <!--</div>-->
    </b-modal>

    <!--********************************************************************-->
    <b-modal id="modal-center"
             ref="rawMaterialModal"
             v-if="showModal === true"
             centered
             size="lg"
             :ok-title="'تایید'"
             title="مواد اولیه مورد نیاز"
             :cancel-title="'لغو'"
    >
      <div class="row mb-2">

        <div class="row my-2 text-center" v-if="nodataProgram">
          <div class="col-12 mt-3">
            <h5>موجودی ثبت نشده است</h5>

          </div>
        </div>
        <div class="row my-2" v-else>
          <div class="col-12 mt-3">
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col" class="text-center">نام محصول</th>
                <th scope="col" class="text-center">واحد</th>
                <th scope="col" class="text-center">نام کارگاه</th>
                <th scope="col" class="text-center">نیاز</th>
                <th scope="col" class="text-center">موجودی</th>
                <th scope="col" class="text-center">کسری</th>
                <th scope="col" class="text-center">موجودی در سایر انبارها</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, indexprogram) in programQuantity">

                <td class="text-center">{{item.name}}</td>
                <td class="text-center">{{item.unitName}}</td>
                <td class="text-center">{{item.companyName}}</td>
                <td class="text-center">{{item.totalNeed}}</td>
                <td class="text-center">{{ item.totalQuantity < 0 ? "(" + item.totalQuantity*-1+"-)":item.totalQuantity}}</td>
                <td class="text-center">{{(item.totalNeed - item.totalQuantity) < 0 ? "---":(item.totalNeed - item.totalQuantity)}}</td>
                <td v-if="item.companyQuantitys == null">
                  <h6 class="text-center">موجودی ثبت نشده است</h6>
                </td>
                <td v-else>
                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th scope="col" class="text-center">نام کارگاه</th>
                      <th scope="col" class="text-center">موجودی انبار</th>
                      <!--<th scope="col" class="text-center">انتقال به کارگاه الگو</th>-->
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(it, indexcompany) in item.companyQuantitys">
                      <td class="text-center">{{it.companyName}}</td>
                      <td class="text-center">{{it.quantity}}</td>
                      <!--<td class="text-center">-->
                        <!--<button class="btn iconed btn-secondary"-->
                                <!--@click="onTransferClicked(indexprogram,indexcompany,programQuantity[indexprogram].totalNeed)"><i-->
                          <!--class="icon-content-duplicate"></i><span>انتقال</span></button>-->
                      <!--</td>-->
                    </tr>
                    </tbody>
                  </table>
                </td>

              </tr>
              </tbody>
            </table>
          </div>

        </div>

      </div>

      <!--</div>-->
    </b-modal>


  </div>
</template>

<style lang="scss">
  //@import '~vuejs-noty/dist/vuejs-noty.css';

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>
<script>
  import VsTable from "../../_framework/VsTable.vue";
  import VsTableMixin from "../../_framework/VsTableMixin.js";
  import axios from "axios";
  import BaseService from "../../_framework/api/BaseService.js";
  import Vue from "vue";
  import Utils from "../../_framework/utils/Utils";
  import Products from "../Products.vue";
  import Moment from "moment-jalali";
  import VsSelect from "../../_framework/VsSelect";
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import VsTableHeaderRow from "../../_framework/VsTableHeaderRow";


  export default {
    props: ["accesses", "userAccess"],
    components: {
      VsTableHeaderRow,
      VsTable,
      VsTableMixin,
      Products,
      Moment,
      VsSelect,
      datePicker: DatePicker,

    },
    mixins: [VsTableMixin],
    beforeMount() {
      // this.options.access = checkAccess(this.$route.path);
      //console.log(this.options.access);
      // this.show = !!this.options.access;
    },
    data() {
      return {
        show: true,
        isLoading: false,
        product: {},
        productPattern: [],
        showPlanningModal: false,

        names: [],
        selectedProductPattern: null,
        model: null,
        showModal: true,
        patterns: null,
        createPatternModel: {
          patternId: 0,
          count: 0,
          orderDetailId: 0
        },
        worksCount: 0,
        workDescription: "",

        planningTime: 0,
        patternTime: 0,
        numbersInTime: 1,
        shiftList: [],
        selectedShifts: [],
        shiftSelectedVal: null,
        dateClicked: 0,
        startDate: null,
        patternId: 0,
        productId: 0,
        timeSheets: [],
        disableDates: [],
        todayDate: null,
        todayDateJ: null,
        selsestDate: null,
        planningList: [],

        planningListCount: null,
        programList: [],
        programListNotsend: [],
        totalCount: 0,
        programListVal: null,
        programListSelected: [],

        deleteprogramListVal: null,
        deleteprogramListSelected: [],

        planningDate: [],
        tempDate: null,
        priority: [],
        selectedPriority:
          {
            title: null,
            value: 0,

          },
        endPlanningDateJ: null,
        endPlanningDate: null,
        startPlanningDateJ: null,
        startPlanningDate: null,
        planning: {},

        nodataDate: true,
        dateQuantity: [],
        programCodeSelected: null,
        productSelected: null,
        programQuantity: [],
        nodataProgram: false,


      };
    },
    mounted() {
      // this.refreshTable();
      // this.getOrderList();
      /* setTimeout(() => {
           console.log(this.$refs.table.list.data)
       },1000)*/
      new BaseService('Works', '/GetWorkPriorities').getList().then((response) => {
        this.priority = response.data;

        // console.log(response.data)
      }).catch((error) => {
        console.log(error)
      });

      this.refreshTable();
      // setTimeout(() => {
      //   // this.getOrderList();
      //   this.calculateWorksCount();
      // }, 500);


      this.todayDate = Moment(new Date());
      this.todayDate = this.todayDate.toJSON().slice(0, 10);
      this.todayDateJ = Moment(this.todayDate.substring(0, 10), "YYYY-MM-DD").format("jYYYY/jMM/jDD");

      let nextMounth = Moment(new Date());
      nextMounth.add(30, 'days');
      nextMounth = nextMounth.toJSON().slice(0, 10);

      this.endPlanningDate = nextMounth;
      this.startPlanningDate = this.todayDate;
      this.getPlanning(this.startPlanningDate, this.endPlanningDate);


    },
    methods: {

      refreshTable() {
        /*this.show = false;
        setTimeout(() => {
            this.show = true;
        }, 500);*/
        // this.$refs.table.onFetchEntityList();
      },
      getFilesInnerBox() {
        let innerBox = {
          options: {
            clickableRows: false,
            hasActions: false,
            isEditable: false
          },
          params: {}
        };

        return innerBox;
      },

      getProduct() {
        this.$refs['productOrder'].show();


      },
      openProductModal() {

        let ComponentClass = Vue.extend(Products);
        let _products = new ComponentClass({
          propsData: {isSelectMode: "true"},
          store: this.$store
        });
        _products.$mount();
        /* if (this.$refs.productsContainer.hasChildNodes) {
             this.$refs.productsContainer.removeChild(
                 this.$refs.productsContainer.childNodes[0]
             );
         }*/
        // this.$refs.productsContainer.appendChild(_products.$el);
        // console.log(this.$refs.selectProductModal);
        if (this.$refs && this.$refs.selectProductModal) {
          // console.log("ok");
          // console.log(_products);

          this.$refs.selectProductModal.show();
        }
        _products.$on("onRowSelect", row => {
          this.selectProduct(row);
        });
        _products.$on("onRowDoubleClicked", row => {
          this.onSelectProductOk(row);
        });
      },
      hideModal() {
        this.$refs.selectProductModal.hide();
      },
      onSelectProductOk() {
        this.hideModal();
        this.show = false;
        let self = this;
        setTimeout(() => {
          this.show = true;
        }, 50);
        setTimeout(() => {
          let data = self.$refs.table.$data.list.data;
          // let entrances = data.map(d => d.entrance);
          // let outputs = data.map(d => d.output);
          // // this.entrancesSum = entrances.reduce(function (a, b) {
          //   return a + b;
          // }, 0);
          // this.outputsSum = outputs.reduce(function (a, b) {
          //   return a + b;
          // }, 0);
          this.stock = data[data.length - 1].stock;
          console.log( this.stock)
          console.log(data)
        }, 500);
      },
      selectProduct(prod) {
        // this.product.id = prod.id;
        // this.product.name = prod.productName;
        // new BaseService('Patterns', '/GetProductPatterns/' + this.product.id).getList().then((response) => {
        //   var a = response.data;
        //
        //   if (a.length === 0) {
        //     Utils.handleErrorWithNotification("هیچ الگویی برای این کالا تعریف نشده است", this.$noty);
        //     // console.log("هیچ الگویی برای این کالا تعریف نشده است");
        //   } else {
        //     this.productPattern = response.data;
        //   }
        // }).catch((error) => {
        //   console.log(error)
        // })
      },
      openProductDetailModal(prod) {
        // console.log(prod);
        new BaseService('Patterns', '/GetProductPatterns/' + prod.id).getList().then((response) => {
          var a = response.data;

          if (a.length === 0) {
            Utils.handleErrorWithNotification("هیچ الگویی برای این کالا تعریف نشده است", this.$noty);
            // console.log("هیچ الگویی برای این کالا تعریف نشده است");
          } else {
            this.product = prod;
            this.productId = prod.id;
            this.names = response.data;
            this.productPattern = response.data;
            // console.log(this.productPattern);
            this.showPlanningModal = true;
            this.$refs.selectProductModal.hide();
            this.getPatterns();
            // this.getStockMaterial();
          }
        }).catch((error) => {
          console.log(error)
        })
        // this.getKardex(val.id);
      },

      onTaminClicked(id) {
        this.$router.push({
          path: "/supply/" + id
        });
      },
      getPlanningData(id, programCodeId) {
        this.programCodeSelected = programCodeId;
        this.productSelected = id;
        this.getPlanningList(id, programCodeId);
        this.getPlanningTime(id, programCodeId);
        this.getPlanningCount(id, programCodeId);

      },
      getPatterns() {


        // new BaseService('Time', '/GetShift').getList().then((response) => {
        //   this.shiftList = response.data;
        //
        // }).catch((error) => {
        //   console.log(error)
        // });

        new BaseService('Time', '/GetShift').getList().then((response) => {
          this.shiftList = response.data;

        }).catch((error) => {
          console.log(error)
        });

        new BaseService('Time', '/GetTimeSheet').getList().then((response) => {
          this.timeSheets = response.data;
          this.disableDates = [];
          for (let i = 0; i < this.timeSheets.length; i++) {
            // console.log(this.timeSheets[i].dateTime);
            // this.timeSheets[i].jdateTime = Moment(this.timeSheets[i].dateTime.substring(0, 10), "YYYY-MM-DD").format("jYYYY-jMM-jDD");
            // this.disableDates.push(this.timeSheets[i].jdateTime);
            this.disableDates.push(Moment(this.timeSheets[i].dateTime.substring(0, 10), "YYYY-MM-DD").format("jYYYY-jMM-jDD"));
          }

        }).catch((error) => {
          console.log(error)
        });
      },
      getOrderList() {
        new BaseService('ProductionManagements', '/GetManageOrder').getList().then((response) => {
          this.refreshTable()
        }).catch((error) => {
          console.log(error)
        });
      },
      sendOrderToProduce() {
        this.$refs['sentToProduct'].show();
        this.programListNotsend = [];
        for (let i = 0; i < this.programList.length; i++) {
          if (!this.programList[i].sendToWorkstation) {
            let str = this.programList[i].programCode + " تعداد " + this.programList[i].counts + " عدد";
            this.programList[i].str = str;
            this.programListNotsend.push(this.programList[i]);
          }
        }
        // console.log(this.programListNotsend)
        new BaseService('Works', '/GetWorkPriorities').getList().then((response) => {
          this.priority = response.data;

          // console.log(response.data)
        }).catch((error) => {
          console.log(error)
        });
      },
      patternSelect(prop, data) {
        this.patternId = data.id;
        this.productId = data.productId;
        this.patternTime = data.standardTime;
        for (let pl of this.planning) {
          if (pl.productId === this.productId) {
            this.totalCount = pl.totlalPlanCount;
          }
        }
        let prods = data.rawMaterials;

        for (let pr of prods) {
          if (pr.productId === this.productId) {
            this.numbersInTime = pr.count;
          }
        }
        this.planningTime = Math.round((this.createPatternModel.count * this.patternTime) / this.numbersInTime);


      },
      countChange() {
        this.planningTime = Math.round((this.createPatternModel.count * this.patternTime) / this.numbersInTime);
      },
      onShiftChange(val) {
        this.selectedShifts = [];

        if (val !== null && val !== undefined) {
          for (let item of val) {
            this.selectedShifts.push(item.id)
          }
        }
      },
      onProgramListChange(val) {
        // console.log(val);
        this.programListSelected = [];
        if (val !== null && val !== undefined) {
          for (let item of val) {
            this.programListSelected.push(item.programCode)
          }
        }
      },
      onDeleteProgramListChange(val) {
        this.deleteprogramListSelected = [];
        if (val !== null && val !== undefined) {
          for (let item of val) {
            this.deleteprogramListSelected.push(item.programCode)
          }
        }
      },
      toggleStartDatePicker() {
        this.dateClicked = 4;
        this.$refs.datePicker4.togglePicker();
      },
      setDateFromDatePicker(date) {
        if (this.dateClicked === 4) {
          this.selsestDate = date;
          let sdate = Moment(date, "jYYYY/jMM/jDD");
          this.startDate = sdate.format("YYYY-MM-DD");
          this.getPlanning(this.startDate, this.startDate);
          // this.sendPrePlanning();
        }
        if (this.dateClicked === 3) {
          this.endPlanningDateJ = date;
          let sdate = Moment(date, "jYYYY/jMM/jDD");
          this.endPlanningDate = sdate.format("YYYY-MM-DD");
          this.getPlanning(this.startPlanningDate, this.endPlanningDate);
        }
        if (this.dateClicked === 1) {
          this.startPlanningDateJ = date;
          let sdate = Moment(date, "jYYYY/jMM/jDD");
          this.startPlanningDate = sdate.format("YYYY-MM-DD");

        }

      },
      sendPrePlanning() {
        if (this.startDate === null) {
          this.$noty.error("لطفا تاریخ شروع برنامه را انتخاب کنید");
        } else if (this.patternId === 0) {
          this.$noty.error("لطفا الگوی تولید را انتخاب کنید");
        } else if (this.createPatternModel.count === 0) {
          this.$noty.error("لطفا تعداد را انتخاب کنید");
        } else if (this.selectedShifts === null || this.selectedShifts.length === 0) {
          this.$noty.error("لطفا شیفتهای کاری را انتخاب کنید");
        } else {
          let model = {
            startDate: this.startDate,
            orderId: 0,
            patternId: this.patternId,
            productId: this.productId,
            count: this.createPatternModel.count,
            shifts: this.selectedShifts,

          };
          // console.log(model);
          new BaseService('Planning', '/CheckPlanningsWithMaterial').create(model).then((response) => {
            // console.log("ok button clicked");
            this.$noty.success(response.data);
            this.getPlanning(this.startPlanningDate, this.endPlanningDate);
          }).catch((error) => {
            // TODO: change error message and put if condition for it
            // this.$noty.error("عدد کار برای این سفارش ثبت شده و دیگر نمیتوانید کار جدید ثبت کنید")
          });
        }
      },
      avilableDate(formatted, dateMoment, checkingFor) {


        let attributes = {'title': 'بدون تعریف' + formatted};
        for (let i = 0; i < this.disableDates.length; i++) {
          if (checkingFor === 'day' && formatted === this.disableDates[i]) {
            // console.log("28")
            attributes['style'] = 'background-color: #f9e1be !important; ';
            attributes['title'] = 'این روز در تقویم کاری تعریف شده است';
          }
        }
        return attributes;
      },
      showOrderTimesheet() {
        this.$refs.datePicker3.togglePicker();
      },
      showOrderTimesheetList() {

        this.$refs['orderPlanningList'].show();
      },
      showdeletePlanModal() {
        this.$refs['deletePlanModal'].show();
      },
      getRawMaterial() {

        new BaseService('Planning', '/GetRawMaterialFromProgramCode/' + this.programCodeSelected).getList().then((response) => {
          if (response.data === null || response.data == "") {
            this.nodataProgram = true;
          } else {
            this.nodataProgram = false;
            this.programQuantity = [];
            this.programQuantity = response.data;
          }
          this.$refs['rawMaterialModal'].show();

        }).catch((error) => {
          Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
          console.log(error)
        });
      },

      getPlanningList(id, programCodeId) {
        let model = {
          orderId: 0,
          patternId: this.patternId,
          productId: id,
          programCodeId: programCodeId
        };
        new BaseService('Planning', '/GetOrderTimeSheetByPogramCode').create(model).then((response) => {
          // console.log("ok button clicked");
          this.planningList = response.data;
          if (this.planningList.length > 0) {
            for (let i = 0; i < this.planningList.length; i++) {
              for (let j = 0; j < this.planningList[i].ordersPrograms.length; j++) {
                // console.log(this.timeSheets[i].dateTime);
                this.planningList[i].ordersPrograms[j].date = Moment(this.planningList[i].ordersPrograms[j].date.substring(0, 10), "YYYY-MM-DD").format("jYYYY-jMM-jDD");
              }
            }
          }
          // this.$noty.success(response.data);

        }).catch((error) => {
          // TODO: change error message and put if condition for it
          // this.$noty.error("عدد کار برای این سفارش ثبت شده و دیگر نمیتوانید کار جدید ثبت کنید")
        });
      },
      getPlanningTime(id, programCodeId) {
        let model = {
          orderId: 0,
          patternId: this.patternId,
          productId: id,
          programCodeId: programCodeId
        };
        new BaseService('Planning', '/GetOrderTimeSheetByDate').create(model).then((response) => {
          // console.log("ok button clicked");
          this.planningDate = response.data;
          if (this.planningDate.length > 0) {
            for (let i = 0; i < this.planningDate.length; i++) {
              // console.log(this.timeSheets[i].dateTime);
              this.planningDate[i].date = Moment(this.planningDate[i].date.substring(0, 10), "YYYY-MM-DD").format("jYYYY-jMM-jDD");
            }
          }
          // this.$noty.success(response.data);

        }).catch((error) => {
          // TODO: change error message and put if condition for it
          // this.$noty.error("عدد کار برای این سفارش ثبت شده و دیگر نمیتوانید کار جدید ثبت کنید")
        });
      },
      getPlanningCount(id, programCodeId) {
        let model = {
          orderId: 0,
          patternId: this.patternId,
          productId: id,
          programCodeId: programCodeId
        };
        new BaseService('Planning', '/GetOrderTimeSheetCount').create(model).then((response) => {
          // console.log("ok button clicked");
          this.planningListCount = response.data;
          this.programList = this.planningListCount.ordersPlans;
          this.totalCount = this.planningListCount.totalCount;
        }).catch((error) => {
          // TODO: change error message and put if condition for it
          // this.$noty.error("عدد کار برای این سفارش ثبت شده و دیگر نمیتوانید کار جدید ثبت کنید")
        });
      },
      highlightOrder(formatted, dateMoment, checkingFor) {
        let attributes = {'title': ''};
        for (let i = 0; i < this.planningDate.length; i++) {
          if (checkingFor === 'day' && formatted === this.planningDate[i].date) {
            // console.log("28")
            attributes['style'] = 'background-color: #a7a040 !important; ';
            let str = "";
            for (let j = 0; j < this.planningDate[i].ordersPlans.length; j++) {
              str = str + ' | ' +
                this.planningDate[i].ordersPlans[j].productName + ' با الگوی ' +
                this.planningDate[i].ordersPlans[j].patterrnName + ' در کارگاه ' +
                this.planningDate[i].ordersPlans[j].companyName + ' کد برنامه ' +
                this.planningDate[i].ordersPlans[j].programCode + ' در شیفت ' +
                this.planningDate[i].ordersPlans[j].shiftName + ' از ساعت ' +
                this.planningDate[i].ordersPlans[j].times;
            }
            attributes['title'] = str;
          }
        }
        return attributes;
      },
      deletPlanning() {
        // let model = {
        //   orderId: this.row.id,
        //   patternId: this.patternId,
        //   productId: this.row.product.id,
        // };
        // console.log(model);
        new BaseService('Planning', '/DeletePogramCode').create(this.deleteprogramListSelected).then((response) => {
          // console.log("ok button clicked");
          // this.planningListCount = response.data;
          // this.programList = this.planningListCount.ordersPlans;
          // this.totalCount = this.planningListCount.totalCount;
          this.$noty.success(response.data);
          this.getPlanningData();
        }).catch((error) => {
          // TODO: change error message and put if condition for it
          this.$noty.error("" + error)
        });
      },
      priorityTitleSelect(prop, data) {
        this.selectedPriority.value = data.value;
        // console.log(this.parameters.priority);
        // if (data && data.id) {
        //   this.voucherModel.documentTypeId = data.id;
        // } else {
        //   this.voucherModel.documentTypeId = null;
        // }
      },
      sendPlanningToProduct() {
        if (this.programListSelected.length > 0) {
          let model = {
            priority: this.selectedPriority.value,
            description: this.workDescription,
            programCode: this.programListSelected

          };
          // console.log(model);
          new BaseService('Planning', '/CreateWorkFromProgramCode').create(model).then((response) => {
            this.$noty.success(response.data);
            this.getOrderList();
            this.getPlanningData();
          }).catch((error) => {
            // TODO: change error message and put if condition for it
            this.$noty.error(error);
          });
        } else {
          this.$noty.error("لطفا کدهای برنامه را انتخاب کنید");
        }
      },
      toggleEndPlanningDatePicker() {
        this.dateClicked = 3;
        this.$refs.datePicker2.togglePicker();
      },
      toggleStartPlanningDatePicker() {
        this.dateClicked = 1;
        this.$refs.datePicker1.togglePicker();
      },
      getPlanning(stdate, endate) {
        let createTimesheet = {
          startDate: stdate,
          endDate: endate
        };
        this.isLoading = true;
        new BaseService('Planning', '/GetAllProductsPlannings').create(createTimesheet).then((response) => {
            this.isLoading = false;
            this.planning = response.data;
            // console.log(this.planning)
          }
        ).catch((error) => {
          this.isLoading = false;
          console.log(error)
        })
      },
      showProgramDetail(id, programCodeId) {
        // console.log(id)
        this.getPlanningData(id, programCodeId);
        this.$refs['productDetail'].show();

      },
      getStockMaterial() {
        let createTimesheet = {
          startDate: this.todayDate,
          endDate: end
        };
        // console.log(createTimesheet);
        new BaseService('Planning', '/GetRawProductFromDateProduct/' + this.productId).create(createTimesheet).then((response) => {
            this.dateQuantity = response.data;
            if (this.dateQuantity.length > 0) {
              this.nodataDate = false;
            } else {
              this.nodataDate = true;
            }
          }
        ).catch((error) => {
          console.log(error)
        })
      },


    }
  };
</script>

<style lang="scss">
  /*.vs-table-header {*/
  /*background-color: beige;*/
  /*}*/

  /*.vs-table-row {*/
  /*transition: .3s;*/
  /*}*/

  /*.vs-table-row:not(.vs-table-header) {*/
  /*background-color: lightgrey;*/
  /*border-bottom: 1px solid white;*/
  /*}*/

  /*.vs-table-row.selected {*/
  /*background-image: linear-gradient(to right, grey , #a5a5a5);*/
  /*color: white*/
  /*}*/
</style>
